import templateUrl from './product-lines-list.component.html'

export const ProductLinesListComponent = {
    controller: ProductLinesListController,
    controllerAs: "vm",
    templateUrl
}

function ProductLinesListController($uibModal, utilityService, productLinesService) {
    'ngInject';
    const vm = this;

    vm.$onInit = activate;

    vm.columns;
    vm.sortColumns = [{ field: "EffectiveDate", dir: -1 }]; // Default
    vm.isSortingByField = isSortingByField;
    vm.columnClass = columnClass
    vm.pageNumber = 1;
    vm.pageSize = 10;
    vm.onSetSort = onSetSort;
    vm.sortProductLines = sortProductLines;
    vm.productLines = [];
    vm.prestineproductLines = [];
    vm.onEdit = onEdit;
    vm.filters = {};
    vm.filterProductLine = filterProductLine;
    vm.onDelete = onDelete;
    function activate() {
        vm.columns = [

            {
                title: "Code #",
                field: "ProductLineCode",
                sortable: true
            },

            {
                title: "Name",
                field: "Name",
                sortable: true
            },
            {
                title: "Description",
                field: "Description",
                sortable: true
            },
            {
                title: "Division",
                field: "DivisionName",
                sortable: true
            },
            {
                title: "Actions",
                field: "Actions",
                sortable: false
            }

        ];

        loadProductLines();
    }
    function loadProductLines() {
        utilityService.showLoading();
        productLinesService.retrieveProductLines()
            .then(function (productLines) {
                vm.productLines = productLines;
            }).catch(function (ex) {
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
                utilityService.hideLoading();
            })
            .then(function () {
                if (vm.productLines) {
                    if ((vm.pageNumber - 1) * vm.pageSize >= vm.productLines.length) {
                        vm.pageNumber = 1;
                    }
                }
                utilityService.hideLoading();

            });
    }

    function getColumn(field) {
        return vm.sortColumns.filter(function (column) {
            return column.field === field;
        })[0];
    }

    function onSetSort(sortField) {
        // TODO: Refactor or use an existing library to handle data table functionality.
        let sortColumn = vm.sortColumns.filter(function (sortColumn) {
            return sortColumn.field === sortField.field;
        })[0];
        if (!sortColumn) {
            // Start dir at -1 (descending) so that it toggles to ascending order by default.
            sortColumn = { field: sortField.field, dir: -1 };
            vm.sortColumns.splice(0, vm.sortColumns.length);
            vm.sortColumns.unshift(sortColumn);
        }
        sortColumn.dir *= -1;
        vm.sortProductLines(vm.productLines);

    }

    function sortProductLines(productLines) {

        return productLines.sort(function (a, b) {
            return vm.sortColumns.reduce(function (comparison, column) {
                // Go through all columns in order and return the value
                // of the first comparison that broke equality (ie, returned non-0).
                if (comparison === 0) {
                    // Still equal.
                    if (a[column.field] < b[column.field]) {
                        return -1 * column.dir;
                    } else if (a[column.field] > b[column.field]) {
                        return column.dir;
                    }
                }
                return comparison;
            }, 0);
        })
    }

    function isSortingByField(field) {
        const column = getColumn(field);
        return !!column;
    }

    function columnClass(field) {
        const column = getColumn(field);
        if (!column) {
            return {};
        }

        return {
            'glyphicon fas fa-sort-amount-down-alt': column.dir > 0,
            'glyphicon fas fa-sort-amount-down': column.dir < 0
        };
    }
    function filterProductLine(productLine) {

        return (!vm.filters.ProductLineCode
            || utilityService.containsInvariant(productLine.ProductLineCode, vm.filters.ProductLineCode))
            && (!vm.filters.Name || utilityService.containsInvariant(productLine.Name, vm.filters.Name))
            && (!vm.filters.Description
                || utilityService.containsInvariant(productLine.Description, vm.filters.Description))
            && (!vm.filters.DivisionName
                || utilityService.containsInvariant(productLine.DivisionName, vm.filters.DivisionName))

    }
    function onEdit(productLine) {
        $uibModal.open({
            template: /*html*/`
                <div class="modal-header"><h1>New Product Line </h1></div>
                <div class="modal-body">
                    <apex-edit-product-line product-line="vm.productLine"
                                            after-submit="vm.afterSubmit(productLine)"></apex-edit-product-line>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-plain float-right" ng-click="vm.close()">Close</button>
                </div>`,
            controller: function ($uibModalInstance, productLine) {
                'ngInject';
                this.productLine = !productLine ? null : productLine;

                this.afterSubmit = function (productLine) {
                    $uibModalInstance.close(productLine);
                };
                this.close = function () {
                    $uibModalInstance.dismiss();
                };
            },
            controllerAs: "vm",
            resolve: {
                productLine: productLine
            },
            windowClass: 'xx-dialog pagespinner',
            size: 'lg',
            backdrop: 'static'
        }).result.then(function (productLine) {
            loadProductLines();
        }).then(function () {
            utilityService.hideLoading();
        })
    }
    function onDelete(productLine) {
        utilityService.showLoading();
        productLinesService.deleteProductLine(productLine.ProductLineID)
            .then(function (productLines) {
                loadProductLines();
            }).catch(function (ex) {
                alert("Delete failed: " + utilityService.getExceptionMessage(ex));
                utilityService.hideLoading();
            })
            .then(function () {
                utilityService.hideLoading();
            });

    }
}
